import {
  required,
  TextInput,
  SimpleForm,
} from 'react-admin';
import { ColorInput } from '@components/inputs/ColorInput';
import LabelIcon from '@mui/icons-material/Label';

const validateRequired = [required()];

export interface TagFormProps extends Record<string, unknown> {
  domain?: string;
}

export const TagForm = ({ domain, ...props }: TagFormProps) => (
  <SimpleForm
    warnWhenUnsavedChanges
    {...props}
    defaultValues={domain ? { domain } : undefined}
  >
    <TextInput
      source="name"
      label="resources.tag.fields.name"
      validate={validateRequired}
      fullWidth
    />
    <ColorInput
      source="color"
      label="resources.tag.fields.color"
      fullWidth
    />
  </SimpleForm>
);

export { TagList } from './List';
export const TagIcon = LabelIcon;
